// api，统一接口管理
import $https, { Instance } from "./request";
import QS from "qs";
/**
 * @description 获取验证码
 * @method get
 * @param {string} param 时间戳
 */
export const veriCode = (param) => {
  return $https.get("/sys/randomImage/" + param);
};

/**
 * @description IP 自动登录
 */
export const ipAutoLogin = () => {
  return Instance.get("/sys/ipAutoLogin", {
    skipIpTokenRefresh: true,
    _ipAutoLoginRequest: true,
  }).then((response) => response.data);
};

/**
 * @description 登录
 * @method post
 * @param {string} username 用户名
 * @param {string} password 密码
 * @param {string} captcha 验证码
 * @param {string} checkKey 生成验证码的随机码
 * @param {string} remember_me 记住我
 * @param {string} personalOrCom 个人或企业，填个人(personal）
 */
export const login = (param) => {
  return $https.post("/sys/login", param);
};

/**
 * @description 退出登录
 * @method post
 * @notes 由后端 LoginController.logout 负责清理 Redis：userToken、shiroAuth、sys:cache:user
 */
export const logout = () => {
  return $https.post("/sys/logout", {});
};

/**
 * @description 查询当前用户可访问菜单及权限
 * @method get
 */
export const queryPermissionsByUser = () => {
  return $https.get("/sys/permission/getUserPermissionByToken");
};

/**
 * @description 修改密码
 * @method put
 * @param {string} oldpassword
 * @param {string} password
 * @param {string} confirmpassword
 */
export const updateMyPass = (param) => {
  return $https.put("/sys/user/updateMyPass", param);
};

/**
 * @description 用户留言-分页列表（客户端仅本人）
 * @method get
 * @param {object} param pageNo、pageSize；可选 userId（仅管理端）
 */
export const sysUserMessageList = (param) => {
  return $https.get("/sys/sysMessage/list", param);
};

/**
 * @description 用户留言-新增（body 传 content）
 * @method post
 * @param {object} param { content }
 */
export const sysUserMessageAdd = (param) => {
  return $https.post("/sys/sysMessage/add", param);
};

/**
 * @description 用户留言-逻辑删除
 * @method delete
 * @param {number|string} id 主键
 */
export const sysUserMessageDelete = (id) => {
  return $https.delete("/sys/sysMessage/delete", { params: { id } });
};

/**
 * @description 图片前缀地址接口
 * @method post
 */
export const getFastDFSPath = (param) => {
  return $https.post("/sys/common/getFastDFSPath", param);
};

/**
 * @description 查询版面数据
 * @method post
 * @param {string} startDate 开始时间
 * @param {string} endDate 结束时间
 * @param {string} cloums 查询字段 paperDate
 * @param {integer} timeLevel 时间等级 1:最近7天，2:最近一月 3:最近半年
 * @param {string} status 新闻的状态值3为已入ES
 * @param {string} pageName 版名
 * @param {string} pageSortNo 版次
 * @param {string} sort 排序，DESC:降序（默认），ASC:升序
 * @param {integer} pageNo 当前页数，默认为？
 * @param {integer} pageSize 每页显示数，默认20，可选[20,30,40,50]
 */
export const newsPageSearch = (param) => {
  return $https.post("/np/gaNpPage/newsPageSearch", param);
};

/**
 * @description 查询版面数据
 * @method post
 * @param {string} itemType 报纸类型
 * @param {string} sort 排序
 * @param {string} startDate 发布日期-开始
 * @param {string} endDate 发布日期-结束
 * @param {string} cloums 排序字段paperDate
 * @param {integer} pageNo 当前页数
 * @param {integer} pageSize 每页显示数
 * @param {string} status 状态值，新闻的状态值3为已入ES
 * @param {string} keywords 查询内容，单输入框查询内容
 * @param {integer} timeLevel 时间等级，空:全部，1:最近7天，2:最近一月 3:最近半年
 * @param {integer} secondSearchFlag 二次检索，0:普通检索，1：二次检索
 * @param {object} preSearchParamMap 上次查询条件
 * @param {integer} toRepeat 是否去重，0 否 1 是
 * @param {integer} filterType 按类型筛选,筛选条件 标题:newsTitle，内容:pureContent，作者:newsAuthor
 * @param {object} searchParams 多维查询条件
 * @param {string} searchParams[].logicSelect 与或非0=and 1=or 2=not
 * @param {string} searchParams[].selectOption 查询的字段名
 * @param {string} searchParams[].input 查询值
 */
export const newsSearch = (param) => {
  return $https.post("/np/gaNpNews/newsSearch", param);
};

/**
 * @description 文章检索结果批量导入专题
 * @method post
 * @param {Array<string>} subjectIds 选中的专题 ID 集合
 * @param {Array<string>} resourceIds 资源 ID 集合
 * @param {Object} search payload 同文章检索条件
 */
export const importNewsSubject = (param) => {
  return $https.post("/sys/subject/addResource", param);
};

/**
 * @description 以图搜图（向量搜索-图片模式）
 * @method post
 * @param {string} imageBase64 上传图片的Base64编码
 * @param {string} imageFileName 上传图片的文件名
 * @param {integer} topN 返回相似数量，默认10
 * @param {string} itemType 文章类型，1:文章，2:图片
 * @param {string} startDate 发布日期-开始
 * @param {string} endDate 发布日期-结束
 */
export const photoSearch = (param) => {
  return Instance.post(`/article/vector/search/photoSearch`, param).then((res) => res.data);
};

/**
 * @description 近似检索（向量搜索）
 * @method post
 * @param {string} keywords 检索关键词
 * @param {integer} topN 返回相似文章数量，默认10
 * @param {string} itemType 文章类型，1:文章，2:图片（作为 URL query 参数）
 * @param {string} startDate 发布日期-开始
 * @param {string} endDate 发布日期-结束
 */
export const vectorSearch = (param) => {
  return Instance.post(`/article/vector/search`, param).then((res) => res.data);
};

/**
 * @description 检索统计接口
 * @method post
 * @param {integer} itemType 统计类型，空:所有数据，1:文章，2:图片，3:广告
 * @param {string} cloums 分组字段，paperDate为报纸日期
 * @param {integer} status 状态值，新闻的状态值3为已入ES
 * @param {string} startDate 发布日期-开始
 * @param {string} endDate 发布日期-结束
 * @param {string} statisticalMethod 统计方式，按年=year、按月=month、按日=day
 * @param {object} searchParams 维查询条件
 * @param {string} searchParams[].logicSelect 与或非0=and 1=or 2=not
 * @param {string} searchParams[].selectOption 查询的字段名
 * @param {string} searchParams[].input 查询值
 */
export const newsStatistic = (param) => {
  return $https.post("/np/statistic/newsStatisticSearch", param);
};

/**
 * @description 获取专题标题列表
 * @method get
 */
/**
 * @description 获取专题分类列表（左侧树）
 * @method get
 * @param {object} param pageSize 等查询参数
 */
export const getSubjectCategoryList = (param) => {
  return $https.get("/sys/subjectCategory/listWithSubjectCount", param);
};

/** 获取专题分类列表（不带计数，用于表单下拉） */
export const getSubjectCategoryListSimple = (param) => {
  return $https.get("/sys/subjectCategory/list", param);
};

/** 查询专题列表 */
export const querySubjects = (param) => {
  return $https.get("/sys/subjectCategory/querySubjects", param);
};

/** 获取标签列表 */
export const getTagList = (param) => {
  return $https.get("/sys/tag/list", param);
};

/** 按专题ID查询汇总统计（文章/图片数量） */
export const querySubjectCountById = (param) => {
  return $https.get("/sys/subject/queryCountBySubjectId", param);
};

/** 按专题ID查询专题详情 */
export const querySubjectById = (param) => {
  return $https.get("/sys/subject/queryById", param);
};

/**
 * @description 专题添加资源（文章/图片/广告）
 * @method post
 * @param {Object} param
 * @param {Array<string>} param.subjectIds 专题ID集合
 * @param {Array<string>} param.resourceIds 资源ID集合
 */
export const addResource = (param) => {
  return $https.post("/sys/subject/addResource", param);
};

/**
 * @description 专题移除资源（文章/图片/广告）
 * @method post
 * @param {Object} param
 * @param {Array<string>} param.subjectIds 专题ID集合
 * @param {Array<string>} param.resourceIds 资源ID集合
 */
export const removeResource = (param) => {
  return $https.post("/sys/subject/removeResource", param);
}
/**
 * @description 查询专题下的资源列表（专题内容列表）
 * @method get
 * @param {Object} param
 * @param {string} param.subjectId 专题ID
 * @param {string} param.type 资源类型
 * @param {string} param.source 来源
 * @param {string} param.keyword 关键字
 * @param {number} param.pageNo 页码
 * @param {number} param.pageSize 每页数量
 */
export const querySubjectResource = (param) => {
  return $https.get("/sys/subject/querySubjectResource", param);
};

/**
 * @description 文献资料库分页查询
 * @method post
 * @param {Object} param
 * @param {string} param.keywords 关键字
 * @param {number|string} param.dbType 数据类型：1报库 2图库 3音视频 4新媒体 5期刊库 6设计稿库 7图书（空=全部）
 * @param {number} param.pageNo 页码（0 起始）
 * @param {number} param.pageSize 每页数量
 */
export const queryLiteratureList = (param) => {
  return $https.post("/sys/literature/list", param);
};

/**
 * @description 历史上的今天-文献资料查询（返回结构同 queryLiteratureList）
 * @method get
 * @param {Object} param
 * @param {number} param.pageNo 页码（0 起始）
 * @param {number} param.pageSize 每页数量
 */
export const queryOnThisDayLiterature = (param) => {
  return $https.get("/sys/literature/onThisDay", param);
};

/**
 * @description 产品检索-产品搜索（eastview 产品检索列表/卡片共用数据）
 * @method post
 * @param {Object} param
 * @param {string} param.keywords 检索关键词
 * @param {string} param.sort 排序：relevance 相关度 / time_desc 时间倒序 / cited_desc 被引 / download_desc 下载
 * @param {number} param.pageNo 页码（1 起始）
 * @param {number} param.pageSize 每页数量
 * @param {Object} param.filters 筛选条件（各分组选中值）
 */
export const searchAllProduct = (param) => {
  return $https.post("/allProduct/search", param);
};

// -----------------------------------------book 专用接口-------------------------------------------

 export const fetchHomeRankings = () => {
  return $https.get('')
 }

/**
 * @description 产品检索-查询指定父产品下的子产品（仅一层主-子结构）。
 *              用于「产品检索」页面点击上级产品时，先判断是否有下级：
 *                - 有下级：在产品页继续展示（递进）
 *                - 无下级：直接跳转详情（如图书 /book/detail/:id）
 * @method get
 * @param {string} parentId 上级产品 ID（ga_all_product.id）
 */
export const getProductChildren = (parentId) => {
  return $https.get("/allProduct/children", { parentId });
};

/**
 * @description 图书检索-图书信息搜索（eastview 图书检索页 /book 专用接口）
 * @method post
 * @param {Object} param
 * @param {string} param.searchWord 检索关键词
 * @param {Array<{field:string, keyword:string}>} [param.searchItems] 顶部搜索条关键词检索条件
 * @param {Array<{field:string, keyword:string}>} [param.filterItems] 左侧筛选项（出版社 publisher / 中国分类法 category / 主题词 cipSubjectWords）
 * @param {string} param.sort 排序（如 time_desc）
 * @param {number} param.pageNo 页码（1 起始）
 * @param {number} param.pageSize 每页数量
 * @param {Array<string>} [param.productLanguage] 语言筛选（value 如 '中文'）
 * @param {Array<string>} [param.category] 图书分类筛选（value 为中文分类名）
 */
export const searchBookInfo = (param) => {
  return $https.post("/book/search/bookInfo", param);
};

/**
 * @description 图书检索-图书具体信息查询
 * @method get
 * @param {string} param.bookId
 */
export const searchBookDetail = (param = {bookId: ''}) => {
  return $https.get("/book/search/detail", param);
};
/**
 * @description 图书检索-图书章节详情查询
 * @method get
 * @param {string} param.bookId
 */
export const fetchBookChapterDetail = (param = {bookId: ''}) => {
  return $https.get("/book/manage/chapters/"+param.bookId);
};

/**
 * @description 章节常规检索（全库检索）
 * @method post
 * @param {Object} param
 * @param {Array<{field:string, keyword:string}>} param.searchItems 检索条件列表
 * @param {Boolean} [param.secondSearch] 是否二次检索
 * @param {Array<{field:string, keyword:string}>} [param.preSearchItems] 上次检索条件（用于二次检索）
 * @param {string} [param.dateType] 日期类型（year/month/day）
 * @param {string} [param.dateStart] 开始日期
 * @param {string} [param.dateEnd] 结束日期
 * @param {string} [param.sortType] 排序（score/dateDesc/dateAsc）
 * @param {number} param.pageNo 页码
 * @param {number} param.pageSize 每页数量
 * @note 后端默认使用精确匹配（match_phrase），不分词
 */
export const chapterNormalSearch = (param) => {
  return $https.post("/book/search/chapter/normal", param);
};

/**
 * @description 图书检索-章节高级检索
 * @method post
 * @param {array} param.searchItems 检索条件（{ field, keyword, logic }）
 * @param {boolean} [param.secondSearch] 是否结果中检索
 * @param {array} [param.preSearchItems] 上次检索条件
 * @param {string} [param.dateType] 日期类型（year/month/day）
 * @param {string} [param.dateStart] 开始日期
 * @param {string} [param.dateEnd] 结束日期
 * @param {string} [param.sortType] 排序（score/dateDesc/dateAsc）
 * @param {number} param.pageNo 页码
 * @param {number} param.pageSize 每页数量
 */
export const chapterAdvancedSearch = (param) => {
  return $https.post("/book/search/chapter/advanced", param);
};

/**
 * @description 图书检索-图片高级检索
 * @method post
 * @param {array} param.searchItems 检索条件（{ field, keyword, logic }）
 *   字段示例：imageTitle（图片标题）
 * @param {string} [param.dateType] 日期类型（year/month/day），未筛选时传空串
 * @param {string} [param.dateStart] 开始日期，未筛选时传空串
 * @param {string} [param.dateEnd] 结束日期，未筛选时传空串
 * @param {string} [param.sortType] 排序（score/dateDesc/dateAsc），未筛选时传空串
 * @param {string} param.pageNo 页码（后端从 1 开始）
 * @param {string} param.pageSize 每页数量
 * @note 返回记录中的 thumbFilePath 为 FastDFS 相对路径，展示时需拼图片前缀
 */
export const imageAdvancedSearch = (param) => {
  return $https.post("/book/search/image/advanced", param);
};

/**
 * @description 图书检索-图书文章内容查询
 * @method get
 * @param {string} bookId
 */
export const searchBookChapter = (bookId) => {
  return $https.get(`/book/read/chapter/list/${bookId}`);
};


/**
 * @description 图书检索-图书文章内容
 * @method get
 * @param {string} chapterId 章节ID
 */
export const searchBookChapterContent = (chapterId) => {
  return $https.get(`/book/read/chapter/${chapterId}`);
};

export const specialQuery = (param = { pid: "", topicName: "", startTime: null, endTime: null, state: "1" }) => {
  return $https.get("/sys/subject/list", param);
};

/**
 * 中国图书分类法分类
 * @param {string} param.parentId 父分类ID
 * @returns 
 */
export const queryBookCategory = (param) => {
  return $https.get("/book/category/children", param);
}

/**
 * 图书出版社列表
 * @returns
 */
export const queryBookPublisher = () => {
  return $https.get("/book/search/getPublisherAndSize");
}

/**
 * 图书主题词统计（分页拉取主题词筛选项）
 * @method post
 * @param {number} param.pageNo 页码（1 起始）
 * @param {number} param.pageSize 每页数量
 * @returns {Promise<{result:{records:Array<{subjectWord:string, bookCount:number}>, total:number, pages:number, current:number}}>}
 */
export const queryCipSubjectWordStat = (param) => {
  return $https.get("/book/search/cip/subjectWord/stat", param);
}


/**
 * 创建下载任务
 * @param {} param {bookId: '', subType: ''} // thumb 缩略图 original大图
 * @returns 
 */
export const createBookImgDownloadTask = (param) => {
  return $https.post("/book/download/imageZip/task", param)
}

// ---------------------------------------------book结束----------------------------------------------------
/**
 * @description 获取专题新闻列表
 * @method post
 * @param {string} topName 专题ID
 * @param {integer} index 当前页数默认值1
 * @param {integer} size 每页显示数
 */
export const newsQuery = (param) => {
  return $https.post("/topic/gaSubject/reception/newsQuery", param);
};

/**
 * @description 获取可选父专题列表
 * @method get
 */
export const getSubjectParents = () => {
  return $https.get("/topic/gaSubject/getByPid");
};

/**
 * @description 创建专题
 * @method post
 */
export const createSubject = (param) => {
  return $https.post("/sys/subject/add", param);
};

/** 上传文件（FormData），返回 message 为文件 URL */
export const uploadFile = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return $https.post("/sys/common/upload", fd);
};

/** 编辑专题 */
export const updateSubject = (param) => {
  return $https.put("/sys/subject/edit", param);
};

/**
 * @description 创建期刊专题
 * @method post
 */
export const createJournalSubject = (param) => {
  return $https.post("/mag/topic/gaSubject/add", param);
};

/**
 * @description 删除专题下的新闻或资源
 * @method post
 * @param {string} subjectId 专题ID
 * @param {Array<string>} newIds 资源ID集合
 */
export const batchDeleteSubjectNews = (param) => {
  return $https.post("/topic/gaSubject/batchDelNews", param);
};


/**
 * @description 删除专题下的期刊资源
 * @method post
 * @param {string} subjectId 专题ID
 * @param {Array<string>} newIds 资源ID集合
 */
export const batchDeleteSubjectJournal = (param) => {
  return $https.post("/mag/topic/gaSubject/batchDelArticle", param);
};

/**
 * @description 注销专题
 * @method post
 */
export const deleteSubject = (param) => {
  return $https.post("/topic/gaSubject/delete", param);
};

/**
 * @description 获取专题详情
 * @method post
 */
export const getSubjectDetail = (param) => {
  return $https.post("/topic/gaSubject/queryById", param);
};

/**
 * @description 校验专题是否存在子专题
 * @method post
 */
export const checkSubjectChildren = (param) => {
  return $https.post("/topic/gaSubject/selectCountByPid", param);
};

/**
 * @description 添加文章到主题
 * @method post
 */
export const addArticle = (param) => {
  return $https.post("/mag/topic/gaSubject/addArticle", param);
};

/**
 * @description 获取专题新闻列表 -- 年鉴
 * @method post
 * @param {string} topName 专题ID
 * @param {integer} index 当前页数默认值1
 * @param {integer} size 每页显示数
 */
export const magQuery = (param) => {
  return $https.post("/mag/topic/gaSubject/searchMagContent", param);
};


/**
 * @description 详情页-获取当前日期的所有版面
 * @method get
 * @param {string} paperIssueNum 期刊号
 */
export const pageTitle = (param) => {
  return $https.get("/np/gaNpPage/pageTitle", param);
};

/**
 * @description 详情页-具体版面及详情接口
 * @method get
 * @param {string} paperIssueNum 期刊号，示例值：jyrb_19881215_00004
 * @param {string} pageSortNo 版面序号,示例值：1
 * @param {string} paperDate 出版日期，示例值：1988-12-15 00:00:00
 * @param {Array} searchParamStrList 详情高亮集合
 * @param {integer} isCalendar 是否日历组件，1是日历组件 0 否
 */
export const pageInfo = (param) => {
  return $https.post("/np/gaNpPage/pageInfo", param);
};

/**
 * @description 日历接口-日期是否有数据查询
 * @method get
 * @param {string} year 年，实例值:2020
 * @param {string} month 月，实例值:12
 * @param {string} paperName 报名，实例值:江阴报
 * @param {string} pageStatus 实例值:3
 */
export const findDateByMonth = (param) => {
  return $https.get("/np/gaNpPage/findDateByMonth", param);
};

/**
 * 解密接口
 * @method get
 * @param {string} plainTxt 待解密地址
 */
export const getDecrypt = (param) => {
  return $https.get("/np/gaNpPage/getUrlText", param);
}

/**
 * 图片详情接口
 * @param {string} id 图片ID
 * @param {string} newsId 新闻ID
 * @param {string} paperIssueNum 期号
 * @param {string} SearchParamStrList 高亮的字段集
 * @param {string} requestIpPath 前缀图片地址
 */
export const newsImageInfo = (param) => {
  return $https.post("/np/gaNpNewsImage/newsImageInfo", param);
}

/**
 * 下载txt文档
 * @param {string} newsId 新闻id
 */
export const exportTxt = (param) => {
  return $https.post("/np/gaNpNews/exportTxt", param, 'arraybuffer');
}

/**
 * 导出新闻图片大图
 * @param {string} imgPath 图片路径
 */
export const exportImgPath = (param) => {
  return $https.post("/np/gaNpNewsImage/exportImgPath", param);
}

/**
 * @description 文章图片简单查询
 * @method post
 * @param {string} newsId 新闻ID
 * @param {string} imgSelfThumPath 图片缩略图路径
 */
export const newsImageSearchSimple = (param) => {
  return $https.post("/np/gaNpNews//newsImageSearchSimple", param);
}

/**
 * 查询当前资源已经翻译过的语种列表
 * @param {string} param
 * @returns
 */
export const getTranslatedLanguageList = (param) => {
  return $https.get("/np/gaNpPage/getTranslatedLanguageByResourceId", param);
}

/**
 * 文本翻译
 * @method post
 * @param {Object} param
 * @param {string} param.content 待翻译文本
 * @param {string} [param.sourceLanguageId] 源语言code值
 * @param {string} [param.sourceLanguage] 源语言编码
 * @param {string} param.targetLanguageId 目标语言code值
 * @param {string} param.targetLanguage 目标语言编码
 * @param {string} [param.promptContent] 可选提示词
 */
export const generateTranslateByText = (param) => {
  return Instance.post("/ai/generateTranslateByText", param, {
    timeout: 60 * 1000,
  }).then((res) => res.data);
};

/**
 * 通过 key 获取翻译结果
 * @method post
 * @param {Object} param
 * @param {string|number} param.id 资源唯一标识
 * @param {string} param.sourceLanguage 源语种
 * @param {string} param.targetLanguage 目标语种
 */
export const getTranslateByKey = (param) => {
  return $https.post("/ai/getTranslateByKey", param);
};

/**
 * 文本摘要
 * @method post
 * @param {Object} param
 * @param {string} [param.id] 备用ID
 * @param {string} param.content 待生成摘要的文本
 * @param {string} [param.promptContent] 可选提示词
 */
export const generateDescriptionByText = (param) => {
  return $https.post("/ai/generateDescriptionByText", param);
};

/**
 * 为指定文章生成AI摘要（持久化到数据库+ES）
 * @method post
 * @param {Object} param
 * @param {string|number} param.articleId 文章ID
 * @param {string} [param.promptContent] 可选提示词
 */
export const generateSummary = (param) => {
  const query = new URLSearchParams();
  if (param && param.articleId != null) {
    query.append("articleId", param.articleId);
  }
  if (param && param.promptContent) {
    query.append("promptContent", param.promptContent);
  }
  let baseUrl = "/news/ai/generateSummary";
  if (param.pageType) baseUrl = "/mag/ai/generateSummary";
  const url = query.toString() ? `${baseUrl}?${query.toString()}` : baseUrl;
  return $https.post(url, {});
};

/**
 * 为指定文章生成AI关键字（持久化到数据库+ES）
 * @method post
 * @param {Object} param
 * @param {string|number} param.articleId 文章ID
 * @param {string} [param.promptContent] 可选提示词
 */
export const generateLabel = (param) => {
  const query = new URLSearchParams();
  if (param && param.articleId != null) {
    query.append("articleId", param.articleId);
  }
  if (param && param.promptContent) {
    query.append("promptContent", param.promptContent);
  }
  let baseUrl = "/news/ai/generateLabel"
  if (param.pageType) baseUrl = "/mag/ai/generateLabel"
  const url = query.toString() ? `${baseUrl}?${query.toString()}` : baseUrl;
  return $https.post(url, {});
};

/**
   * AI 标引：提取文章关键信息
   * @method post
   * @param {Object} param
   * @param {string} [param.id] 备用ID
   * @param {string} param.content 文章内容
   * @param {Array<string>} param.fields 需要提取的字段列表
   * @param {string} [param.promptContent] 可选提示词
   */
export const generateArticleKeywordByText = (param) => {
  return $https.post("/ai/generateArticleKeywordByText", param);
};

/**
 * AI 标引：根据正文生成关键词标签
 * @method post
 * @param {Object} param
 * @param {string} [param.id] 备用ID
 * @param {string} param.content 文章内容
 * @param {string} [param.promptContent] 可选提示词
 */
export const generateLabelByText = (param) => {
  return $https.post("/ai/generateLabelByText", param);
};

/**
 * 通过服务器代理下载图片
 * @param {string} path 图片相对路径
 */
export const downloadImageByPath = (path) => {
  return Instance({
    url: `/sys/common/static/${encodeURI(path)}`,
    method: "get",
    responseType: "blob",
  }).then((res) => res.data);
};

/**
 * 通过服务器代理下载NP图片
 * @param {Object} param 请求参数集合
 * @param {string} param.queryJson 查询条件JSON字符串
 * @param {string} param.imagePath 图片相对路径
 */
export const downloadNpImageByPath = (param) => {
  return Instance({
    url: `/sys/common/static-np`,
    method: "post",
    headers: {
      "Content-Type": "application/json;charset=utf-8",
    },
    data: param,
    responseType: "blob",
  }).then((res) => res.data);
};

/**
 * 根据图片ID查找相似图片
 * @param {Object} param 请求参数
 * @param {number} param.itemType 内容类型（2=图片）
 * @param {string} param.id 当前图片ID
 * @param {number} param.topN 返回数量
 * @param {string} [param.excludeId] 排除的记录ID
 */
export const findSimilarImagesByVectorId = (param) => {
  return Instance.post(`/article/vector/similar`, param).then((res) => res.data);
};

/**
 * 提交图片处理任务
 * @param {Object} param 请求参数
 * @param {string} [param.imageId] 图片记录ID（可选，与imageUrl二选一）
 * @param {string} [param.imageUrl] 图片URL（imageId为空时使用）
 * @param {string} [param.code] 提示词标识（对应 sys_ai_prompts.code，如 fix、colorize、fixBW、mosaicFace）
 */
export const submitImageProcessTask = (param) => {
  return Instance.post(`/np/imageProcess/submit`, null, { params: param }).then((res) => res.data);
};

/**
 * 查询图片处理任务结果
 * @param {string} taskId ComfyUI任务ID
 */
export const getImageProcessResult = (taskId) => {
  return Instance.get(`/np/imageProcess/result`, { params: { taskId } }).then((res) => res.data);
};

/**
 * 保存处理结果：上传到FastDFS并更新数据库
 * @param {Object} param
 * @param {string} param.imageId 图片记录ID
 * @param {string[]} param.resultUrls ComfyUI返回的原始URL列表
 * @param {string[]} param.localFilePaths 对应的本地临时文件路径列表
 * @param {string} param.code 提示词标识（对应 sys_ai_prompts.code，如 fix、colorize、fixBW、mosaicFace）
 */
export const saveImageProcessResult = (param) => {
  return Instance.post(`/np/imageProcess/save`, param).then((res) => res.data);
};

/**
 * 保留指定的处理结果
 * @param {Object} param
 * @param {string} param.imageId 图片记录ID
 * @param {string} param.fastdfsPath FastDFS路径或ComfyUI原始URL
 * @param {string} param.code 提示词标识（对应 sys_ai_prompts.code，如 fix、colorize、fixBW、mosaicFace）
 */
export const keepImageProcessResult = (param) => {
  return Instance.post(`/np/imageProcess/keep`, null, { params: param }).then((res) => res.data);
};

/**
 * 获取当前已保存的AI处理结果
 * @param {string} imageId 图片记录ID
 * @param {string} [code=fix] 提示词标识（对应 sys_ai_prompts.code，如 fix、colorize、fixBW、mosaicFace）
 */
export const getCurrentAiImage = (imageId, code = "fix") => {
  return Instance.get(`/np/imageProcess/current`, { params: { imageId, code } }).then((res) => res.data);
};

/**
 * 获取当前已保存的所有类型AI处理结果Map
 * 返回 { fix: "url", colorize: "url" }
 */
export const getCurrentAiImageMap = (imageId) => {
  return Instance.get(`/np/imageProcess/currentMap`, { params: { imageId } }).then((res) => res.data);
};

// ============= AI修图样例图片处理（Redis存储）============

/**
 * 提交AI修图样例图片处理任务
 * @param {Object} param
 * @param {string} [param.sampleId] 图片记录ID
 * @param {string} [param.imageUrl] 图片URL
 * @param {string} [param.code] 提示词标识
 */
export const submitRetouchSampleTask = (param) => {
  return Instance.post(`/ai/retouchSample/submit`, null, { params: param }).then((res) => res.data);
};

/**
 * 查询AI修图样例任务结果
 * @param {string} taskId 任务ID
 */
export const getRetouchSampleResult = (taskId) => {
  return Instance.get(`/ai/retouchSample/result`, { params: { taskId } }).then((res) => res.data);
};

/**
 * 保留AI修图样例处理结果（存储到Redis）
 * @param {Object} param
 * @param {string} param.sampleId 图片记录ID
 * @param {string} param.pathOrUrl FastDFS路径或ComfyUI原始URL
 * @param {string} [param.code] 提示词标识
 */
export const keepRetouchSampleResult = (param) => {
  return Instance.post(`/ai/retouchSample/keep`, null, { params: param }).then((res) => res.data);
};

/**
 * 获取AI修图样例当前已保存的所有类型AI处理结果Map
 * @param {string} sampleId 图片记录ID
 */
export const getRetouchSampleCurrentMap = (sampleId) => {
  return Instance.get(`/ai/retouchSample/currentMap`, { params: { sampleId } }).then((res) => res.data);
};

/**
 * 获取图片处理类型的提示词列表（从数据库查询，带浏览器本地缓存）
 * @param {string} category 一级分类，如 "imageProcess"
 * @param {number} [status=1] 状态：1=启用
 */
export const listImageProcessPrompts = (category, status = 1) => {
  const params = new URLSearchParams({ category, status: String(status) });
  return Instance.get(`/sys/aiPrompt/listByCategory?${params.toString()}`).then((res) => res.data);
};

// ========== AI修图样本列表模块 API ==========

/**
 * 分页查询AI修图样本列表
 * @param {Object} param
 * @param {string} [param.title] 标题（模糊查询）
 * @param {string} [param.srcPath] 存储路径（模糊查询）
 * @param {number} [param.pageNo] 当前页码，默认1
 * @param {number} [param.pageSize] 每页条数，默认20
 */
export const queryAiRetouchSampleList = (param) => {
  return $https.get("/ai/listAiRetouchSample", param);
};
/**
 * 根据提示词类别返回对应的列表
 * @param {*} category
 * @param {*} status
 * @returns
 */
const listProcessPromptsByCategory = (category, status = 1) => {
  const params = new URLSearchParams({ category, status: String(status) });
  return Instance.get(`/sys/aiPrompt/listByCategory?${params.toString()}`).then((res) => res.data);
};

/**
 * 获取文本处理类型的提示词列表（从数据库查询，带浏览器本地缓存）
 * @returns
 */
export const listTextProcessPrompts = () => {
  const category = "textFix";
  const status = 1;
  return listProcessPromptsByCategory(category, status);
};

/**
 * 获取翻译后的文章内容
 * @param {articleId} param
 * @returns
 */
export const getTranslated = (articleId) => {
  const params = new URLSearchParams({ articleId });
  return Instance.get(`/np/gaNpPage/getTranslatedEnglishData?${params.toString()}`).then((res) => res.data);
};

/**
 * 获取翻译历史记录列表
 * @param {string} resourceId 资源唯一标识
 * @param {string} [destLanguageId] 目标语种标识（可选，用于按语种过滤）
 * @returns
 */
export const getTranslatedHistory = (resourceId, destLanguageId) => {
  const destParam = destLanguageId ? `&destLanguageId=${destLanguageId}` : ''
  return Instance.get(`/np/gaNpPage/getTranslatedHistory?resourceId=${resourceId}${destParam}`).then((res) => res.data);
}

/**
 * 获取语种列表
 * @returns
 */
export const getTranslatedLanguage = () => {
  return Instance.get(`/ai/getLanguage`).then((res) => res.data);
}

/**
 * 删除单条或者全部翻译记录（传了了id则只删除一条记录，否则删除所有）
 * @param {*} id
 * @returns
 */
export const deleteTranslatedHistory = (param) => {
  return Instance.post(`/np/gaNpPage/deleteTranslatedHistory`, param).then((res) => res.data);
}

// --------------------------------个人中心----------------------------------
/**
 * 添加/取消收藏
 * @param {*} dbType 1报库2图库3音视频4新媒体5期刊库6设计稿库7图书
 * @param {*} bizId  资源ID
 * @param {*} action  1 收藏0取消收藏
 * 
 * @returns 
 */
export const addOrCancelFavorite = (dbType, bizId, action = 1) => {
  return $https.post(`/sys/collection/${dbType}/${bizId}?action=${action}`)
}

/**
 * 校验是否收藏过
 * @param {*} dbType 
 * @param {*} bizId 
 * @returns 
 */
export const checkFavorite = (dbType, bizId) => {
  return $https.get(`/sys/collection/${dbType}/${bizId}/check`)
}

/**
 * 获取收藏列表
 * @param {*} dbType  数据库类型 0是全部
 * @param {object} [param] pageNo 当前页（1 起始）、pageSize 每页条数
 * @returns {Promise<{result:{records:Array,total:number,current:number,pages:number}}>}
 */
export const fetchFavoriteList = (dbType, param) => {
  return $https.get(`/sys/collection/list/${dbType}`, param)
}

/**
 * 获取下载列表
 * @returns 
 */
export const fetchDownloadList = (param) => {
  return $https.get('/book/download/task/list', param)
}

/**
 * 留言列表
 */
export const fetchLeaveWords = (param = {}) => {
  param = QS.stringify(Object.assign(param, {
    column: 'createdTime',
    order: 'desc',
  }))
  return $https.post(`/sys/gaGuestbook/list?${param}`)
}

/**
 * 添加留言
 */
export const addLeaveWord = (param) => {
  return $https.post('/sys/gaGuestbook/add', param)
}


/**
 * 删除留言
 */
export const deleteLeaveWord = (id) => {
  return $https.delete(`/sys/gaGuestbook/delete?id=${id}`)
}


/* ==================== 批注（正文高亮 + 笔记） ==================== */
/*
 * mainId / subId 是评论系统的主体与子主体：批注挂在「书 + 章」上，
 * 传的分别是 bookId 与 chapterId。增改删也要带，否则后端无法回答
 * 按 mainId + subId 的列表查询。
 */

/**
 * @description 按章节查批注列表
 * @param {object} param { mainId: bookId, subId: chapterId }
 * @returns {Promise<{code:number, message:string, result:Array}>}
 */
export const fetchCommentList = (param) => {
  return $https.get('/sys/comment/list', param)
}

/**
 * @description 新增批注
 * @param {object} param { id, mainId, subId, startMeta, endMeta, text, note, createTime }
 */
export const addComment = (param) => {
  return $https.post('/sys/comment/add', param)
}

/**
 * @description 更新批注，参数同新增
 */
export const updateComment = (param) => {
  return $https.post('/sys/comment/update', param)
}

/**
 * @description 删除批注
 * @param {string} id 批注 id
 */
export const deleteComment = (id) => {
  return $https.delete(`/sys/comment/${id}`)
}
